"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseCompleteAccountActivation = PurchaseCompleteAccountActivation;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _lucideReact = require("lucide-react");
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _reserhubAccount = require("@/actions/reserhubAccount");
var _ReserhubAccount = require("@/context/ReserhubAccount");
var _errorMonitoring = _interopRequireDefault(require("@/errorMonitoring"));
var _useExperimentalFeature = _interopRequireDefault(require("@/hooks/useExperimentalFeature"));
var _checkoutAccountActivation = require("@/metrics/user-analytics/checkoutAccountActivation");
var _basisTheorySelectors = require("@/selectors/basisTheorySelectors");
var _commerceApiClient = require("services/commerce-api/commerceApiClient");
var _AccountActivationOtpChallenge = require("./AccountActivationOtpChallenge");
var _PurchaseCompleteBenefitIcon = require("./PurchaseCompleteBenefitIcon");
var _accountActivationOtp = require("./accountActivationOtp");
require("./purchaseCompleteAccountActivation.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var OTP_LENGTH = 6;
var PLACEMENT = 'Purchase Complete';
var SIGNUP_BENEFIT_ICONS = ['profile', 'cart', 'card'];
function reportUnexpectedError(error, stage) {
  if ((0, _accountActivationOtp.accountActivationErrorTranslationKey)(error) !== 'errors.generic') return;
  _errorMonitoring["default"].notify({
    error: error instanceof Error ? error : new Error('Purchase Complete enrollment failed'),
    info: {
      message: 'Purchase Complete enrollment failed',
      stage: stage
    }
  });
}
function challengeStorageKey(purchaseToken) {
  return "purchase-complete-account-activation:".concat(purchaseToken);
}
function storeChallenge(purchaseToken, challenge, expiresAt, resendAfterSeconds) {
  var expiration = Date.parse(expiresAt);
  if (!Number.isFinite(expiration)) return;
  (0, _accountActivationOtp.storeAccountActivation)(challengeStorageKey(purchaseToken), _objectSpread(_objectSpread({
    type: 'challenge'
  }, challenge), {}, {
    expiresAt: expiration,
    resendAvailableAt: Date.now() + resendAfterSeconds * 1000
  }));
}

/** Offers email enrollment after a completed guest purchase. */
function PurchaseCompleteAccountActivation(_ref) {
  var accountId = _ref.accountId,
    _ref$email = _ref.email,
    email = _ref$email === void 0 ? '' : _ref$email,
    _ref$firstName = _ref.firstName,
    firstName = _ref$firstName === void 0 ? '' : _ref$firstName,
    _ref$lastName = _ref.lastName,
    lastName = _ref$lastName === void 0 ? '' : _ref$lastName,
    purchaseToken = _ref.purchaseToken,
    _ref$isExchange = _ref.isExchange,
    isExchange = _ref$isExchange === void 0 ? false : _ref$isExchange;
  var _useTranslation = (0, _reactI18next.useTranslation)('payment'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var features = (0, _reactRedux.useSelector)(function (state) {
    var _state$whitelabelConf;
    return ((_state$whitelabelConf = state.whitelabelConfig) === null || _state$whitelabelConf === void 0 ? void 0 : _state$whitelabelConf.features) || {};
  });
  var allowedAuthMethods = (0, _reactRedux.useSelector)(function (state) {
    var _state$whitelabelConf2;
    return ((_state$whitelabelConf2 = state.whitelabelConfig) === null || _state$whitelabelConf2 === void 0 || (_state$whitelabelConf2 = _state$whitelabelConf2.env) === null || _state$whitelabelConf2 === void 0 || (_state$whitelabelConf2 = _state$whitelabelConf2.reserhub) === null || _state$whitelabelConf2 === void 0 || (_state$whitelabelConf2 = _state$whitelabelConf2.auth) === null || _state$whitelabelConf2 === void 0 ? void 0 : _state$whitelabelConf2.allowedAuthMethods) || [];
  });
  var accountHomeUrl = (0, _reactRedux.useSelector)(function (state) {
    var _state$whitelabelConf3;
    return ((_state$whitelabelConf3 = state.whitelabelConfig) === null || _state$whitelabelConf3 === void 0 || (_state$whitelabelConf3 = _state$whitelabelConf3.env) === null || _state$whitelabelConf3 === void 0 || (_state$whitelabelConf3 = _state$whitelabelConf3.reserhub) === null || _state$whitelabelConf3 === void 0 || (_state$whitelabelConf3 = _state$whitelabelConf3.account) === null || _state$whitelabelConf3 === void 0 ? void 0 : _state$whitelabelConf3.homeUrl) || '/account';
  });
  var basisTheoryAvailable = (0, _reactRedux.useSelector)(function (state) {
    return (0, _basisTheorySelectors.selectBasisTheoryInitializationConfig)(state).enabled;
  });
  var _useReserhubAccount = (0, _ReserhubAccount.useReserhubAccount)(),
    accountEnabled = _useReserhubAccount.enabled,
    isUserFetched = _useReserhubAccount.isUserFetched,
    user = _useReserhubAccount.user;
  var featureEnabled = (0, _useExperimentalFeature["default"])('CHECKOUT_ACCOUNT_ACTIVATION') === true;
  var normalizedEmail = email.trim().toLowerCase();
  var normalizedFirstName = firstName.trim();
  var normalizedLastName = lastName.trim();
  var _useState = (0, _react.useState)(function () {
      return (0, _accountActivationOtp.readStoredAccountActivation)(challengeStorageKey(purchaseToken));
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    storedActivationState = _useState2[0];
  var restoredChallenge = (storedActivationState === null || storedActivationState === void 0 ? void 0 : storedActivationState.type) === 'challenge' ? storedActivationState : null;
  var restoredDismissal = (storedActivationState === null || storedActivationState === void 0 ? void 0 : storedActivationState.type) === 'dismissed';
  var _useState3 = (0, _react.useState)(function () {
      return restoredChallenge ? {
        methodId: restoredChallenge.methodId,
        mode: restoredChallenge.mode
      } : null;
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    challenge = _useState4[0],
    setChallenge = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    completed = _useState6[0],
    setCompleted = _useState6[1];
  var _useState7 = (0, _react.useState)(restoredDismissal),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    dismissed = _useState8[0],
    setDismissed = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    code = _useState10[0],
    setCode = _useState10[1];
  var _useState11 = (0, _react.useState)(''),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    errorKey = _useState12[0],
    setErrorKey = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    loading = _useState14[0],
    setLoading = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    verifying = _useState16[0],
    setVerifying = _useState16[1];
  var _useState17 = (0, _react.useState)(function () {
      return restoredChallenge ? Math.max(0, Math.ceil((restoredChallenge.resendAvailableAt - Date.now()) / 1000)) : 0;
    }),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    countdown = _useState18[0],
    setCountdown = _useState18[1];
  var requested = (0, _react.useRef)(Boolean(challenge) || restoredDismissal);
  var invitationTracked = (0, _react.useRef)(false);
  var sendingRef = (0, _react.useRef)(false);
  var verifyingRef = (0, _react.useRef)(false);
  var mounted = (0, _react.useRef)(true);
  var purchaseHasAccount = accountId !== undefined && accountId !== null;
  var visible = featureEnabled && allowedAuthMethods.includes('email') && accountEnabled && isUserFetched && !user && !purchaseHasAccount && !isExchange && Boolean(purchaseToken && normalizedEmail && normalizedFirstName && normalizedLastName);
  var requestOtp = (0, _react.useCallback)(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var mode,
      requestType,
      resolvedMode,
      client,
      methodId,
      expiresAt,
      resendAfterSeconds,
      response,
      loginRequest,
      _response,
      _loginRequest,
      _response2,
      nextChallenge,
      _args = arguments,
      _t,
      _t2;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          mode = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'signup';
          requestType = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'initial';
          if (!sendingRef.current) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return");
        case 1:
          sendingRef.current = true;
          setLoading(true);
          setErrorKey('');
          (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentStarted)({
            mode: mode,
            requestType: requestType,
            authMethod: 'email',
            placement: PLACEMENT
          });
          resolvedMode = mode;
          _context.prev = 2;
          client = (0, _commerceApiClient.getCommerceApiClient)();
          if (!(mode === 'signup')) {
            _context.next = 9;
            break;
          }
          _context.prev = 3;
          _context.next = 4;
          return client.accounts.registerWithEmailOTP({
            email: normalizedEmail,
            firstName: normalizedFirstName,
            lastName: normalizedLastName,
            locale: (0, _accountActivationOtp.accountActivationOtpLocale)()
          });
        case 4:
          response = _context.sent;
          methodId = response.emailId;
          expiresAt = response.expiresAt;
          resendAfterSeconds = response.resendAfterSeconds;
          _context.next = 8;
          break;
        case 5:
          _context.prev = 5;
          _t = _context["catch"](3);
          if (!((0, _accountActivationOtp.accountActivationSemanticCode)(_t) !== 'EMAIL_OTP_ACCOUNT_ALREADY_EXISTS')) {
            _context.next = 6;
            break;
          }
          throw _t;
        case 6:
          resolvedMode = 'login';
          loginRequest = {
            email: normalizedEmail,
            locale: (0, _accountActivationOtp.accountActivationOtpLocale)()
          };
          _context.next = 7;
          return client.accounts.loginWithEmailOTP(loginRequest);
        case 7:
          _response = _context.sent;
          methodId = _response.emailId;
          expiresAt = _response.expiresAt;
          resendAfterSeconds = _response.resendAfterSeconds;
        case 8:
          _context.next = 11;
          break;
        case 9:
          _loginRequest = {
            email: normalizedEmail,
            locale: (0, _accountActivationOtp.accountActivationOtpLocale)()
          };
          _context.next = 10;
          return client.accounts.loginWithEmailOTP(_loginRequest);
        case 10:
          _response2 = _context.sent;
          methodId = _response2.emailId;
          expiresAt = _response2.expiresAt;
          resendAfterSeconds = _response2.resendAfterSeconds;
        case 11:
          if (mounted.current) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return");
        case 12:
          nextChallenge = {
            methodId: methodId,
            mode: resolvedMode
          };
          setChallenge(nextChallenge);
          storeChallenge(purchaseToken, nextChallenge, expiresAt, resendAfterSeconds);
          setCode('');
          setCountdown(resendAfterSeconds);
          (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentOtpSent)({
            mode: resolvedMode,
            requestType: requestType,
            authMethod: 'email',
            placement: PLACEMENT
          });
          _context.next = 15;
          break;
        case 13:
          _context.prev = 13;
          _t2 = _context["catch"](2);
          if (mounted.current) {
            _context.next = 14;
            break;
          }
          return _context.abrupt("return");
        case 14:
          reportUnexpectedError(_t2, 'otp_request');
          setErrorKey((0, _accountActivationOtp.accountActivationErrorTranslationKey)(_t2));
          (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentFailed)({
            mode: resolvedMode,
            authMethod: 'email',
            stage: 'otp_request',
            errorCode: (0, _accountActivationOtp.accountActivationSemanticCode)(_t2),
            requestType: requestType,
            placement: PLACEMENT
          });
        case 15:
          _context.prev = 15;
          sendingRef.current = false;
          if (mounted.current) setLoading(false);
          return _context.finish(15);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 13, 15, 16], [3, 5]]);
  })), [normalizedEmail, normalizedFirstName, normalizedLastName, purchaseToken]);
  (0, _react.useEffect)(function () {
    if (!visible || dismissed || requested.current) return;
    requested.current = true;
    requestOtp();
  }, [dismissed, requestOtp, visible]);
  (0, _react.useEffect)(function () {
    if (!challenge || invitationTracked.current) return;
    invitationTracked.current = true;
    (0, _checkoutAccountActivation.trackAccountEnrollmentInvitationViewed)({
      mode: challenge.mode,
      authMethod: 'email',
      placement: PLACEMENT
    });
  }, [challenge]);
  (0, _react.useEffect)(function () {
    return function () {
      mounted.current = false;
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (countdown <= 0) return undefined;
    var timer = window.setTimeout(function () {
      return setCountdown(function (value) {
        return value - 1;
      });
    }, 1000);
    return function () {
      return window.clearTimeout(timer);
    };
  }, [countdown]);
  var verifyOtp = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(otp) {
      var activeElement, failureStage, refreshedUser, nextError, _t3;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!challenge || otp.length !== OTP_LENGTH || verifyingRef.current)) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return");
          case 1:
            verifyingRef.current = true;
            activeElement = document.activeElement;
            if (activeElement instanceof HTMLInputElement && activeElement.dataset.inputOtp !== undefined) {
              activeElement.blur();
            }
            setVerifying(true);
            setErrorKey('');
            (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentOtpSubmitted)({
              mode: challenge.mode,
              authMethod: 'email',
              placement: PLACEMENT
            });
            failureStage = 'otp_validation';
            _context2.prev = 2;
            _context2.next = 3;
            return (0, _commerceApiClient.getCommerceApiClient)().accounts.validateOTPCode('POST', JSON.stringify({
              code: otp,
              methodId: challenge.methodId,
              associatePurchases: true
            }), {
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 3:
            failureStage = 'session_refresh';
            _context2.next = 4;
            return dispatch((0, _reserhubAccount.fetchReserhubUser)());
          case 4:
            refreshedUser = _context2.sent;
            if (mounted.current) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return");
          case 5:
            if (refreshedUser !== null && refreshedUser !== void 0 && refreshedUser.id) {
              _context2.next = 6;
              break;
            }
            throw new Error('Unified account refresh failed');
          case 6:
            (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentSucceeded)({
              mode: challenge.mode,
              authMethod: 'email',
              placement: PLACEMENT
            });
            (0, _accountActivationOtp.removeStoredAccountActivation)(challengeStorageKey(purchaseToken));
            setCompleted(true);
            _context2.next = 9;
            break;
          case 7:
            _context2.prev = 7;
            _t3 = _context2["catch"](2);
            if (mounted.current) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return");
          case 8:
            reportUnexpectedError(_t3, failureStage);
            setCode('');
            nextError = (0, _accountActivationOtp.accountActivationErrorTranslationKey)(_t3);
            setErrorKey(nextError);
            if (nextError === 'errors.invalid_code') setCountdown(0);
            (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentFailed)({
              mode: challenge.mode,
              authMethod: 'email',
              stage: failureStage,
              errorCode: (0, _accountActivationOtp.accountActivationSemanticCode)(_t3),
              placement: PLACEMENT
            });
          case 9:
            _context2.prev = 9;
            verifyingRef.current = false;
            if (mounted.current) setVerifying(false);
            return _context2.finish(9);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 7, 9, 10]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [challenge, dispatch, purchaseToken]);
  function handleCodeChange(value) {
    var digits = value.replace(/\D/g, '').slice(0, OTP_LENGTH);
    setCode(digits);
    if (errorKey) setErrorKey('');
    if (digits.length === OTP_LENGTH) verifyOtp(digits);
  }
  function close() {
    if (challenge) {
      (0, _checkoutAccountActivation.trackCheckoutAccountEnrollmentDismissed)({
        mode: challenge.mode,
        authMethod: 'email',
        placement: PLACEMENT
      });
    }
    (0, _accountActivationOtp.storeAccountActivation)(challengeStorageKey(purchaseToken), {
      type: 'dismissed'
    });
    setDismissed(true);
  }
  if (dismissed) return null;
  if (completed) {
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "relative my-4 rounded-3xl bg-gray-50 px-5 py-7 text-center shadow-md sm:px-10",
      "data-testid": "purchase-complete-account-activation-success"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "absolute right-4 top-4 rounded p-1 text-gray-500 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary-regular",
      "aria-label": t('checkout_account_activation.close'),
      onClick: function onClick() {
        return setDismissed(true);
      }
    }, /*#__PURE__*/_react["default"].createElement(_lucideReact.X, {
      "aria-hidden": "true",
      className: "h-5 w-5"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "pr-6 text-sm text-gray-600"
    }, t('purchase_complete_account_activation.success_intro')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mt-3 flex items-start justify-center gap-2"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-success-regular text-white"
    }, /*#__PURE__*/_react["default"].createElement(_lucideReact.Check, {
      "aria-hidden": "true",
      className: "h-4 w-4",
      strokeWidth: 3
    })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-base font-semibold text-gray-800"
    }, t('purchase_complete_account_activation.success_title')), /*#__PURE__*/_react["default"].createElement("p", {
      className: "mt-1 text-sm text-gray-600"
    }, t('purchase_complete_account_activation.success_description')))), /*#__PURE__*/_react["default"].createElement("a", {
      className: "mt-4 inline-flex rounded-full bg-white px-6 py-2 text-sm font-semibold text-primary-regular shadow-md focus:outline-none focus:ring-2 focus:ring-primary-regular",
      href: accountHomeUrl
    }, t('purchase_complete_account_activation.login_cta')));
  }
  if (!visible || !challenge && !errorKey) return null;
  if (challenge) {
    var descriptionKey = "purchase_complete_account_activation.".concat(challenge.mode, "_description_").concat(basisTheoryAvailable ? 'cards' : 'history', "_").concat(features.DOTERS_ENABLED === true ? 'loyalty' : 'plain');
    var BenefitIcon = /*#__PURE__*/_react["default"].createElement("div", {
      className: "relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-regular text-white"
    }, SIGNUP_BENEFIT_ICONS.map(function (icon, index, icons) {
      return /*#__PURE__*/_react["default"].createElement(_PurchaseCompleteBenefitIcon.PurchaseCompleteBenefitIcon, {
        key: icon,
        type: icon,
        className: "absolute h-6 w-6 object-contain ".concat(icons.length > 1 ? "account-activation-icon account-activation-icon-".concat(index + 1) : '')
      });
    }));
    return /*#__PURE__*/_react["default"].createElement(_AccountActivationOtpChallenge.AccountActivationOtpChallenge, {
      description: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, challenge.mode === 'signup' ? /*#__PURE__*/_react["default"].createElement("span", null, t('purchase_complete_account_activation.signup_title'), ". ") : null, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
        t: t,
        i18nKey: descriptionKey,
        values: {
          email: normalizedEmail
        },
        components: {
          email: /*#__PURE__*/_react["default"].createElement("strong", {
            className: "font-semibold text-gray-800"
          })
        }
      })),
      helpText: t('checkout_account_activation.login_code_help'),
      leadingVisual: BenefitIcon,
      code: code,
      errorMessage: errorKey ? t("checkout_account_activation.".concat(errorKey)) : undefined,
      invalid: errorKey === 'errors.invalid_code',
      loading: loading,
      verifying: verifying,
      countdown: countdown,
      onCodeChange: handleCodeChange,
      onClose: close,
      onResend: function onResend() {
        return requestOtp(challenge.mode, 'resend');
      },
      testId: "purchase-complete-account-activation-otp",
      autoFocus: true
    });
  }
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "my-4 rounded-xl border border-gray-200 bg-white p-4 text-center shadow-md",
    "data-testid": "purchase-complete-account-activation-error",
    "data-sentry-component": "PurchaseCompleteAccountActivation",
    "data-sentry-source-file": "PurchaseCompleteAccountActivation.tsx"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm text-error-strong",
    role: "alert"
  }, t("checkout_account_activation.".concat(errorKey))), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "mt-3 rounded-md bg-primary-regular px-4 py-2 text-sm font-semibold text-white disabled:opacity-50",
    disabled: loading,
    onClick: function onClick() {
      return requestOtp('signup', 'retry');
    }
  }, loading ? t('checkout_account_activation.sending') : t('checkout_account_activation.retry')));
}